import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNewUsers } from "../../redux/actions/usersActions";
import "./NewUsers.css";
import { IonCard, IonCardContent, IonIcon, IonToast } from "@ionic/react";
import { followVisitedProfile } from "../../redux/actions/visitedProfileActions";
import { updateFollowing } from "../../redux/actions/currentProfileActions";
import { Link } from "react-router-dom";
import { personAddOutline, add } from "ionicons/icons";

import Avatar from "../../components/avatar/Avatar";

export const NewUsersSection = () => {
  const dispatch = useDispatch();
  const { newUsers, loading } = useSelector((state) => state.users);
  const { data: currentUser } = useSelector((state) => state.currentProfile);
  const [showToast, setShowToast] = useState(false);
  const [followCount, setFollowCount] = useState(0);

  useEffect(() => {
    dispatch(getNewUsers());
  }, [dispatch]);

  const handleFollowAll = async () => {
    if (!newUsers) return;

    const usersToFollow = newUsers.filter((user) => {
      if (user._id === currentUser?._id) return false;
      const isFollowing = currentUser?.following?.some(
        (followingUser) => followingUser.username === user.username,
      );
      return !isFollowing;
    });

    if (usersToFollow.length === 0) return;

    for (const user of usersToFollow) {
      await dispatch(followVisitedProfile(user.username)).then(() => {
        dispatch(updateFollowing({ profile: user, action: "follow" }));
      });
    }

    setFollowCount(usersToFollow.length);
    setShowToast(true);
  };

  if (loading && !newUsers) return null; // Or a loading skeleton
  if (!newUsers || newUsers.length === 0) return null;

  // Show up to 5 avatars
  const displayUsers = newUsers;
  const shortName = (name) => (name.length > 8 ? name.slice(0, 8) + "…" : name);
  return (
    <>
      <IonCard className="ll-card">
        <IonCardContent className="ll-card__content">
          {/* Avatars */}
          <div className="ll-card__avatars">
            <Link to="/new-post" className="ll-new-post-link">
              <div className="ll-avatar-container">
                <Avatar
                  size="lg--new-post" // Changed to md to match the smaller profile scale in the feed
                  className="ll-new-post-avatar"
                  username={currentUser.username}
                  avatar={currentUser.avatar}
                  province={currentUser.province}
                  isNewPostAvatar={true}
                />
                <div className="ll-add-icon-wrapper">
                  <IonIcon icon={add} className="ll-add-icon" />
                </div>
              </div>
              <span className="ll-new-post-title">You</span>
            </Link>

            {displayUsers.map((user) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Avatar
                  key={user._id}
                  avatar={user.avatar}
                  username={user.username}
                  province={user.province}
                  size="lg" // 50px
                  isFounder={user.isFounder}
                  isOfficial={user.isAdmin}
                />

                <Link
                  to={`/profile/${user.username}`}
                  style={{
                    marginTop: "4px",
                    fontSize: "12px",
                    color: "#666",
                    textDecoration: "none",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "75px",
                  }}
                >
                  {user.fname || user.username}
                </Link>
              </div>
            ))}
          </div>
          {/* Header */}
          {/* <div className="ll-card__header">
            <div className="ll-card__title">
              <span>
                🍁Today's Loons · {newUsers.length > 0 && newUsers.length} 👋{" "}
                <Link to="/friends" className="ll-card__subtitle-link">
                  Say hi
                </Link>
              </span>
            </div>
          </div> */}
          {/* Subtitle */}
          {/* <div className="ll-card__subtitle">
            <Link to="/friends" className="ll-card__subtitle-link">
              👋 Say hi
            </Link>{" "}
            to{" "}
            {newUsers.slice(0, 2).map((user, index) => (
              <span key={user._id}>
                <Link
                  to={`/profile/${user.username}`}
                  style={{ fontWeight: "bold", color: "inherit" }}
                >
                  {user.username}
                </Link>
                {index < 1 && newUsers.length > 1 ? ", " : " "}
              </span>
            ))}
            {newUsers.length > 2 && `and ${newUsers.length - 2} others...`}
          </div> */}

          {/* <div
            style={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <IonButton
              routerLink="/friends"
              fill="clear"
              shape="round"
              className="ll-friends-button"
            >
              <IonIcon
                slot="start"
                icon={peopleCircleOutline}
                style={{
                  marginRight: "4px",
                }}
              ></IonIcon>{" "}
              Friends
            </IonButton>
            <IonButton
              onClick={handleFollowAll}
              shape="round"
              className="ll-follow-button"
            >
              Follow ({newUsers.length})
            </IonButton>
          </div> */}
        </IonCardContent>
      </IonCard>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={`You are now following ${followCount} new Canadians!`}
        duration={3000}
        position="bottom"
        color="dark"
        icon={personAddOutline}
      />
    </>
  );
};
